// extracted by mini-css-extract-plugin
export default {"code":"z_ch"};